module.exports = "/virtual-football-league/img/amblems/left/logos/Schalke.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/virtual-football-league/img/amblems/left/logos/Schalke.png
// module id = 2123
// module chunks = 4